import * as React from 'react';
import { ORG_ROLE } from '@config/index';

export interface OrgInfo {
  id: string;
  name: string;
  role: ORG_ROLE;
  icon?: string;
  plan?: number;
  createDate?: string;
  description?: string;
  isTemplate: boolean;

  // for copilot
  copilotEnabled?: boolean;
  copilotBotId?: string;
  copilotBotName?: string;
  copilotBotUrl?: string;

  // for local usase
  oriCache?: OrgInfo;
}

export interface OrgContextProps {
  org?: OrgInfo;
  handleOrg: (org?: OrgInfo, callback?: () => void) => void;
}

export const OrgContext = React.createContext<OrgContextProps>({
  org: undefined,
  handleOrg: (org?: OrgInfo) => {
    // Do nothing
  }
});

export interface OrgMember {
  userId: string;
  userName: string;
  phone: string;
  mail: string;
  role: ORG_ROLE;
}

export interface OrgOutsideMember extends OrgMember {
  outsider: true;
  agentId: string;
  agentName: string;
  agentRole: string;
}

export function orgToLocal(res: any): OrgInfo {
  return {
    id: res.id,
    name: res.name,
    role: res.role,
    icon: res.icon,
    plan: res.plan,
    createDate: res.create_date,
    description: res.description,
    isTemplate: res.is_template,
    copilotEnabled: res.copilot_enabled,
    copilotBotId: res.copilot_bot_id,
    copilotBotName: res.copilot_bot_name,
    copilotBotUrl: res.copilot_bot_url
  };
}


export function orgMemberToLacal(data: any): OrgMember {
  return {
    userId: data.user_id,
    userName: data.nickname,
    phone: data.phone,
    mail: data.mail,
    role: data.role
  };
}

export function orgOutsiderToLocal(data: any): OrgOutsideMember {
  return {
    ...orgMemberToLacal(data),
    userName: data.user_nickname,
    agentId: data.agent_id,
    agentName: data.agent_nickname,
    agentRole: data.role,
    outsider: true
  };
}
